module.exports = __webpack_public_path__ + "img/curtain_up_10.5c5f3b02.svg";